import React from 'react';
import {Link} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
export default function Footer() {
    const { t } = useTranslation();
    return (<footer className="footer">
            <div className="container">
                <div className="footer-content">
                    <div className="footer-section">
                        <h3>CedarKids</h3>
                        <p>NIP: 9512463564</p>
                        <p>Address: Ul. Brzozowa 36/3, 85-154 Bydgoszcz, Polska </p>
                        <p>Email: info@cedarkids.eu</p>
                        <p>WhatsApp/Tel.: <a href='tel:+48452816914'>+48 452 816 914</a></p>

                    </div>

                    <div className="footer-section">
                        <h4>{t('footer.navigation')}</h4>
                        <ul>
                            <li><Link to="/">{t('header.swingSets')}</Link></li>
                            <li><Link to="/shipping">{t('header.shipping')}</Link></li>
                            <li><Link to="/contacts">{t('header.contacts')}</Link></li>
                            <li><Link to="/installation">{t('header.installation')}</Link></li>
                            <li><Link to="/about">{t('header.about')}</Link></li>
                        </ul>
                    </div>

                    <div className="footer-section">
                        <h4>{t('footer.followUs')}</h4>
                        <div className="social-links">
                            <a href="https://www.instagram.com/cedarkids.insta?igsh=Nmd0ZXVzMmg4d29v" target="_blank" rel="noopener noreferrer">{t('footer.instagram')}</a>
                            <a href="https://www.facebook.com/share/1Dgcgy1UUM/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer">{t('footer.facebook')}</a>
                            <a href="https://www.tiktok.com/@cedarkids.eu?_r=1&_t=ZS-9825Gwbxlpw" target="_blank" rel="noopener noreferrer">TikTok</a>
                        </div>
                        <ul>
                            <li><Link to="/assembly">{t('header.assembly')}</Link></li>
                        </ul>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>&copy; {new Date().getFullYear()} CedarKids. {t('footer.rights')}</p>
                    <p className="creator">{t('footer.createdBy')} <a href="https://github.com/yawdenisk" target="_blank"
                                                         rel="noopener noreferrer">Denys Ivashchenko</a></p>
                </div>
            </div>
        </footer>);
}
